 /* ---------------------------------------------
   CSS BANNER WAIT
   --------------------------------------------- */  
   function css_banner_builded(){
    if ($('.banner-css').length <= 0) {return;}
    var css_banner = '';
    var array_banner = new Array;
    $('.banner-css').each(function(){
      var sectionType = $(this).data().sectionType;
      if (array_banner.indexOf(sectionType) >= 0) {return}else{array_banner.push(sectionType)}
      css_banner += $(this)[0].innerText;
    });
    css_banner = css_banner.replace(/<.*?>/gm,'').replace(/(\r\n|\n|\r|\s\s)/gm, "");
    if ($('.css_banner_builded').length == 0) {
      $('script').first().before('<style class="css_banner_builded">'+css_banner+'</style>');
    }else{
      $('.css_banner_builded').html(css_banner)
    }
    $('.wait-for-css').removeClass('wait-for-css');
  }

 

$(document).ready(function() {
  css_banner_builded();
  var box = $(".desc");
  var readMoreButton = $(".read-more-button");
  
  // Get the truncate height from CSS custom property
  var minimumHeight = parseInt(getComputedStyle(box[0]).getPropertyValue('--truncate-height'));
  
  // Function to get the current full height
  function getFullHeight() {
    var currentHeight = box.height();
    box.css('height', 'auto');
    var fullHeight = box.height();
    box.height(currentHeight);
    return fullHeight;
  }
  
  // Initial check if content can be expanded
  var initialFullHeight = getFullHeight();
  
  if (initialFullHeight > minimumHeight) {
    readMoreButton.show();
  } else {
    box.removeClass('desc-truncated');
  }

  readMoreButton.on('click', function () {
    var currentFullHeight = getFullHeight();
    
    if (box.hasClass('desc-truncated')) {
      box.animate({ height: currentFullHeight }, function() {
        box.removeClass('desc-truncated');
      });
      readMoreButton.text('Read Less');
    } else {
      box.animate({ height: minimumHeight }, function() {
        box.addClass('desc-truncated');
      });
      readMoreButton.text('Read More');
    }

    $('html, body').animate({
      scrollTop: box.offset().top
    });
  });
});